import '../css/pages/about.css'
import { AboutAnimation } from "../component/Transitions";
import email from "../img/mail.svg"
import call from "../img/call.svg"
import photo from "../img/photo.jpg"
import { useState } from 'react';

export default function About() {
  const [titleAnimation,setTitleAnimation] = useState({opacity:0});
  const [contactAnimation, setContactAnimation] = useState({opacity:0,marginRight: '-280px'});
  const [skillsAnimation, setSkillsAnimation] = useState({width:'0%',marginLeft:'-150px'})
  const [progressBar,setProgressBar] = useState({width:'0%'})

  const allStyle = () => {
    setTimeout(() => {
      setTitleAnimation({transition: "all 0.3s linear"})
    }, 1500);
    setTimeout(() => {
      setContactAnimation({transition: "all 0.3s linear"})
    }, 2200);
    setTimeout(() => {
      setSkillsAnimation({transition: "all 0.5s linear"})
    }, 2700);
    setTimeout(() => {
      setProgressBar({transition: "all 2s 0s ease-out"})
    }, 3200);
  }

  setTimeout(() => {
    document.getElementById('trigger').checked = true
  }, 1);

  return (
    <div class="about" onLoad={allStyle}>
      <AboutAnimation>
        <div className="title" style={titleAnimation}>
          <h1>MUHAMMAD LUTHFI NOER</h1>
          <h3>Front-End Developer</h3>
        </div>
        <div className="about-content">
          <div className="about-contact">
            <div style={contactAnimation} ></div>
            <h3 style={contactAnimation}>I'm a front-end developer from Indonesia skilled with Javascript Stack especially for Front-End website.</h3>
              <h3 className='textMobile' style={titleAnimation}>I'm a front-end developer from Indonesia skilled with Javascript Stack especially for Front-End website.</h3>
            <h3 className="email" style={contactAnimation}><a href="mailto:luthfi.noer18@gmail.com">luthfi.noer18@gmail.com</a></h3>
            <a href="mailto:luthfi.noer18@gmail.com" className='mail'><img src={email} alt="" className='contactAnimation' style={contactAnimation} /></a>
            <h3 className="phone" style={contactAnimation}><a href="tel:+628558948504">+62 855-8948-504</a></h3>
            <a href="tel:+628558948504" className='call'><img src={call} alt="" style={contactAnimation} /></a>
              <a href="mailto:luthfi.noer18@gmail.com" className='mailMobile'><img src={email} alt="" style={titleAnimation} /></a>
              <a href="tel:+628558948504" className='callMobile'><img src={call} alt="" style={titleAnimation} /></a>
            
          </div>
          <div className="about-photo" style={{'backgroundImage': `url(${photo})`}}></div>
          <div className="about-skills">
            <div className="html" style={skillsAnimation}><div style={progressBar}>HTML</div></div>
            <div className="css" style={skillsAnimation}><div style={progressBar}>CSS</div></div>
            <div className="javascript" style={skillsAnimation}><div style={progressBar}>Javascript</div></div>
            <div className="reactjs" style={skillsAnimation}><div style={progressBar}>ReactJS</div></div>
            <div className="nodejs" style={skillsAnimation}><div style={progressBar}>NodeJS</div></div>
            <div className="uidesign" style={skillsAnimation}><div style={progressBar}>UI Design/Figma</div></div>
          </div>
        </div>
      </AboutAnimation>
    </div>
  )
}